<template>
  <div id="our-team" class="mx-auto max-w-screen-xl">
    <MoleculesLoadingOverlay v-if="loading" />
    <Organisms v-else :organisms="organisms" />
  </div>
</template>

<style>
#our-team {
  #organism-1.brand-window-slant {
    img {
      @apply object-bottom;
    }

    h1 {
      @apply flex gap-[0.5ch] justify-center lg:justify-start flex-wrap;
    }
  }

  #join-our-team-cta.brand-window-text-overlay {
    @apply min-h-0 p-12;

    h2 {
      @apply text-center;
    }

    .content {
      @apply text-lg text-left max-w-4xl w-full px-0;
    }
  }
}
</style>

<script setup>
import { useAsyncQuery } from "#imports";
import { GET_ORGANISMS } from "~/graphql/GetOrganisms";
import { storeToRefs } from "pinia";
const breadcrumbs = useBreadcrumbs();
const { breadcrumbsList } = storeToRefs(breadcrumbs);

breadcrumbsList.value = [{ title: "Our Team", link: "" }];

const { data, pending, error } = await useAsyncQuery(GET_ORGANISMS, {
  uri: "/about-us/our-team/",
});

const organisms = computed(() => {
  return data.value?.organisms?.hlOrganisms?.hlOrganism ?? [];
});

const loading = pending;
</script>
